module.exports = __webpack_public_path__ + "static/media/present.c5f4e138.svg";